module.exports = __webpack_public_path__ + "static/media/statusOnline.2e7666b7.svg";